$(document).ready(function(){

    function updateFreeShippingBar() {

        const progressBar = document.querySelector('.freeShippingBar .progress');
        const text = document.querySelector('.shippingText');

        if (!progressBar || !text) return;

        // reset
        progressBar.style.width = "0%";

        setTimeout(() => {
            progressBar.style.width = "100%";
        }, 100);

        text.innerText = "🎉 You got FREE Shipping!";
    }

    const target = document.querySelector('#MinimogCartDrawer');
    const shippingBar = document.querySelector('.freeShippingWrapper');

    if (target) {

        const observer = new MutationObserver((mutations) => {

            // check empty cart
            const emptyCart = target.querySelector('.m-cart-drawer__empty');

            if (emptyCart) {

                console.log("Cart Empty ❌");

                if (shippingBar) {
                    shippingBar.style.display = "none";
                }

            } else {

                if (shippingBar) {
                    shippingBar.style.display = "block";
                }
            }

            mutations.forEach((mutation) => {

                if (
                    mutation.type === "attributes" &&
                    mutation.attributeName === "class"
                ) {

                    if (target.classList.contains("m-cart-drawer--active")) {

                        console.log("Drawer Open ✅");

                        updateFreeShippingBar();

                    } else {

                        console.log("Drawer Closed ❌");

                    }
                }
            });
        });

        observer.observe(target, {
            attributes: true,
            attributeFilter: ['class'],
            childList: true,
            subtree: true
        });
    }

    $('body').on('click', '.mineSizeBtn', function(){
        $('#KiwiSizingChart button').click();
    });

});